/* eslint-disable react/prop-types */
/**
 * Catcher Functional Component
 *
 * Responsible for substitute crashed branches in React render tree by
 * some FallbackComponent and avoid the application to crash literally.
 * Further more, Catcher handles and log the errors.
 *
 * This component encapsulates the well known react-error-boundary
 * library, available in: https://www.npmjs.com/package/react-error-boundary.
 *
 */

import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import useIssue from '../../model/useIssue';
import useCredentials from '../../model/useCredentials';

export default function Catcher(props) {
  const { children } = props;

  const { commands: issuesCommands } = useIssue();
  const { sharedStates: credentialsStates } = useCredentials();

  const errorHandler = (error, info) => {
    
    const name = credentialsStates.name;
    const whatsapp = credentialsStates.whatsapp;
    const message = error.response
      ? `\
        Front Error!
        Requisição:
          - URL: ${error.config?.method}${error.config?.url}
          - Dados: ${error.config?.data}
          - Parametros: ${error.config?.params}
          - Queries: ${error.config?.query}

        Resposta:
          - Status: ${error.response?.data.statusCode}
          - Código: ${error.response?.data.code}
          - Mensagem: ${error.response?.data.message}
          - Validação: ${error.response?.data.validation?.keys.join(',')}

        ErrorInfo: ${JSON.stringify(info)}`
      : `\
        Front Error!
        Error: ${error.message}
        Stack: ${error.componentStack}
        ErrorInfo: ${JSON.stringify(info)}`;

    if(!(error.message === 'Network Error'|| [500, 503].includes(error.response?.status))) {
      issuesCommands.createIssue({ user: { name, whatsapp }, message });
    }
  };

  return (
    <ErrorBoundary {...props} onError={errorHandler}>
      {children}
    </ErrorBoundary>
  );
}
